



import React, { useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import { Switch, Grid, IconButton, TextField, Tooltip, FormControlLabel, Checkbox, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import {
  gatewaysActiveItem,
  gatewaysRemoveActiveItem,
  gatewaysRemoveActiveItemById,
  gatewaysRemoveActive
} from '../../../../../reducers/gateways/gatewaysReducers';
import { CustomTable } from '../../../../common/Tables/CustomTable/CustomTable';
import { GatewaysOptionsMenu } from '../../../Options/GatewaysOptionsMenu/GatewaysOptionsMenu';
import { InventoryColumnSelector } from '../../../../Inventory/InventoryColumnSelector/InventoryColumnSelector';

export const GatewaysList = ({ data, columns }) => {

  //las columnas que se ven por defecto
  const [visibleColumnIds, setVisibleColumnIds] = useState(['select', 'id', 'gateway_number', 'status_date', 'ip', 'dimming_profile_id', 'exception_profile_id', 'status_flag', 'serial_number', 'deleteAndSummary']);
  const displayedColumns = columns.filter(column => visibleColumnIds.includes(column.id));


  const [search, setSearch] = useState('');
  const activeItem = useSelector(state => state.gateways.active);
  const totalItems = useSelector(state => state.gateways.gateways)

  const dispatch = useDispatch();

  const handleSelect = (gatewayId, isChecked) => {
    if (isChecked) {
      dispatch(gatewaysActiveItem({ id: gatewayId }));
    } else {
      dispatch(gatewaysRemoveActiveItemById(gatewayId));
    }
  };

  const handleUnSelectAll = () => {
    dispatch(gatewaysRemoveActive([]));
    dispatch(gatewaysRemoveActiveItem([]));
  };

  const handleSelectAll = (isChecked) => {
    if (isChecked) {
      filteredData.forEach(gateway => {
        if (!activeItem.some(item => item.id === gateway.id)) {
          dispatch(gatewaysActiveItem({ id: gateway.id }));
        }
      });
    } else {
      dispatch(gatewaysRemoveActiveItem());
    }
  };

  const handleInputChange = (event) => {
    setSearch(event.target.value);
  };

  const filteredData = useMemo(() => {
    return data.filter((row) =>
      search.length === 0
        ? true
        : columns.some((column) => {
          const value = row[column.id];
          return value && String(value).toLowerCase().includes(search.toLowerCase());
        })
    );
  }, [data, search, columns]);

  const allSelected = useMemo(() => {
    return filteredData.length > 0 && filteredData.every(gateway => activeItem.some(item => item.id === gateway.id));
  }, [filteredData, activeItem]);

  return (
    <Grid container className='animate__animated animate__fadeIn animate__fast'>
      <Grid item sm={5}>
        <TextField
          id="search"
          label="Buscar"
          type="search"
          name="search"
          autoComplete="off"
          value={search}
          onChange={handleInputChange}
          fullWidth
        />
      </Grid>

      <Grid item sm={2}>
        <Tooltip title="Eliminar todo">
          <IconButton edge="end" aria-label="delete" onClick={handleUnSelectAll}>
            <DeleteSweepIcon style={{ fontSize: 30 }} />
          </IconButton>
        </Tooltip>
      </Grid>

      <Grid item sm={3} style={{ marginTop: '25px' }} >
        <Typography>
          <strong>{activeItem.length}</strong> / {totalItems.length} Gateways seleccionados
        </Typography>
      </Grid>
      <Grid item sm={2} style={{ marginTop: '25px' }}>
        <InventoryColumnSelector columns={columns} visibleColumns={visibleColumnIds} onChange={setVisibleColumnIds} columnsIgnored={['select', 'deleteAndSummary']} />
      </Grid>
      <Grid item sm={5} style={{ display: 'flex', alignItems: 'center' }}>
        <FormControlLabel
          control={
            <Switch
              checked={allSelected}
              onChange={(event) => handleSelectAll(event.target.checked)}
              color="primary"
            />
          }
          label="Marcar/Desmarcar todos"
        />
      </Grid>

      <Grid item style={{ width: '100%', marginTop: '16px' }}>
        <CustomTable
          rows={filteredData.map((gateway) => ({
            ...gateway,
            select: (
              <Checkbox
                checked={activeItem.some(item => item.id === gateway.id)}
                onChange={(event) => handleSelect(gateway.id, event.target.checked)}
              />
            ),
            deleteAndSummary: <GatewaysOptionsMenu id={gateway.id} />,
          }))}
          columns={displayedColumns}
        />
      </Grid>
    </Grid>
  );
};

GatewaysList.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
};


